import { FIREBASE_RELATIONS } from 'common/components/constant';

export const getParticipantGroupSessionsPath = (participantGroupId: string | number) =>
  `${FIREBASE_RELATIONS.PARTICIPANT_GROUPS}/${participantGroupId}/${FIREBASE_RELATIONS.PARTICIPANT_GROUP_SESSIONS}`;

export const getParticipantGroupSessionPath = (
  participantGroupId: string | number,
  sessionId: string | number,
) => `${getParticipantGroupSessionsPath(participantGroupId)}/${sessionId}`;

export const getParticipantGroupAudioCallsPath = (participantGroupId: string | number) =>
  `${FIREBASE_RELATIONS.PARTICIPANT_GROUPS}/${participantGroupId}/${FIREBASE_RELATIONS.PARTICIPANT_GROUP_AUDIO_CALL}`;

export const getParticipantGroupAudioCallPath = (
  participantGroupId: string | number,
  sessionId: string | number,
) => `${getParticipantGroupAudioCallsPath(participantGroupId)}/${sessionId}`;
